import { Appear } from "@components/motion/Appear"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Two Column Text",
  tags: ["#page"],
}

export default defineBlock("content/two-column-text", (props) => {
  return (
    <div className="content-sized my-blockSpace grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-5">
      <Appear slide>
        <EditableText
          className="border-l w-full text-balance type-serif-xl-regular px-5 md:px-4"
          store="title"
          defaultValue="Primary text"
          placeholder="Primary text"
        />
      </Appear>
      <Appear slide delay={150}>
        <EditableText
          store="body"
          className="w-full type-serif-lg-regular text-pretty [&_a]:underline"
          defaultValue="Body text"
          placeholder="Body text"
        />
      </Appear>
    </div>
  )
})
